import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { AfterContentInit, ChangeDetectorRef, Component, DoCheck, Input, ViewContainerRef } from '@angular/core';
import { UnRx } from '@pebula/utils';

@Component({
  selector: '[sg-scrollable]',
  host: {
    class: 'sg-full-width sg-full-height',
    style: 'overflow-y: auto; overflow-x: hidden',
  },
  templateUrl: './scrollable.component.html',
  styleUrls: ['./scrollable.component.scss'],
  standalone: false,
})
@UnRx()
export class SgScrollableComponent implements DoCheck, AfterContentInit {
  @Input() get disableTopShadow(): boolean {
    return this._disableTopShadow;
  }
  set disableTopShadow(value: boolean) {
    if (value !== this._disableTopShadow) {
      this._disableTopShadow = value;
    }
  }

  @Input() get disableBottomShadow(): boolean {
    return this._disableBottomShadow;
  }
  set disableBottomShadow(value: boolean) {
    if (value !== this._disableBottomShadow) {
      this._disableBottomShadow = value;
    }
  }

  showTopShadow: boolean;
  showBottomShadow: boolean;
  private _disableTopShadow = false;
  private _disableBottomShadow = false;
  private _hostElement: HTMLElement;
  private _height: number;

  constructor(
    private vcRef: ViewContainerRef,
    private cdr: ChangeDetectorRef
  ) {
    this._hostElement = vcRef.element.nativeElement;

    fromEvent(this._hostElement, 'scroll')
      .pipe(debounceTime(1), UnRx(this))
      .subscribe(() => {
        this.syncScrollState();
      });
  }

  ngDoCheck(): void {
    if (this._height && this._height !== this._hostElement.scrollHeight) {
      this._height = this._hostElement.scrollHeight;
      this.syncScrollState();
    }
  }

  ngAfterContentInit(): void {
    this._height = this._hostElement.scrollHeight;
    this.syncScrollState();
  }

  syncScrollState() {
    const canScrollUp = this._hostElement.scrollTop > 0;
    const canScrollDown = this._hostElement.scrollTop + this._hostElement.clientHeight < this._hostElement.scrollHeight;

    this.showTopShadow = canScrollUp ? true : false;
    this.showBottomShadow = canScrollDown ? true : false;
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }
}
